export const ATTRIBUTION_GROUP_REPORT_ID = 'attribution-group';
